import { GTM } from '../../../../../../helpers'
import getDifferenceInDays from '../../../../../../helpers/getDifferenceInDays'
import nrLogger from '../../../../../../helpers/nrLogger'
import { PromotionStorageManager } from '../../../../../../helpers/promotions'
import formatInventories from './formatInventories'
import formatItems from './formatItems'
import formatItemsGroundDeliveryTime from './formatItemsGroundDeliveryTime'

const executeGTM = (oItems, skuArray, shippingAdjustment = null) => {
  try {
    const orderItems = formatItems(oItems)
    const stepName = 'Proceed To Checkout'
    const option = window.localStorage && window.localStorage.getItem('paymentMethod')
      ? window.localStorage.getItem('paymentMethod')
      : 'creditCard'

    const {
      checkoutStep,
      getProductFromCartItemData,
    } = GTM

    const inventories = formatInventories(oItems)
    const itemsGroundDeliveryTime = formatItemsGroundDeliveryTime(oItems)
    const promotionManager = new PromotionStorageManager()
    const products = orderItems.map(orderItem => {
      const isFromProductOption = skuArray.includes(orderItem.skuNumber)
      const promotionDetails = promotionManager.getPromotionDetailsBySku(orderItem.skuNumber)

      const currentItem = oItems.find(item => item.product.sku === orderItem.skuNumber)
      const groundShippingOption = currentItem?.shippingOption?.options?.find(shpOption => shpOption.method.toLowerCase() === 'ground')
      const standardShippingLeadtime = getDifferenceInDays({ dateToCompare: groundShippingOption?.deliveryDate, asString: false })
      return getProductFromCartItemData(
        {
          ...orderItem,
          inventory: inventories[orderItem.productId] || {},
          isFromProductOption,
          groundDeliveryTime: itemsGroundDeliveryTime[orderItem.productId] || '',
          promotionDetails,
          standardShippingLeadtime,
        },
        orderItem.quantity,
      )
    })

    checkoutStep({
      step: 1,
      stepName,
      option,
      products,
      shippingAdjustment,
    })
  } catch (error) {
    nrLogger.error('ShoppingCartV2.ProceedToCheckout.Regular.executeGTM', error)
  }
}

export default executeGTM
